import { render, staticRenderFns } from "./ReturnPickup.vue?vue&type=template&id=2d4a9bda&scoped=true"
import script from "./ReturnPickup.vue?vue&type=script&lang=js"
export * from "./ReturnPickup.vue?vue&type=script&lang=js"
import style0 from "./ReturnPickup.vue?vue&type=style&index=0&id=2d4a9bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a9bda",
  null
  
)

export default component.exports